import React from 'react';
import { SvgIconProps } from '@mui/material';

export const SavedIcon: React.FC<SvgIconProps> = (props) => (
    <svg
        width="25"
        height="34"
        viewBox="0 0 25 34"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M23.5 17.875V32.875L12.25 21.625L1 32.875V17.875V4.75C1 2.67893 2.67893 1 4.75 1H19.75C21.8211 1 23.5 2.67893 23.5 4.75V8.5"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default SavedIcon;
